import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteNames } from "../../../navigation/RouteNames";
import { registerUser } from "../../../store/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useTranslation } from "../../../translations/i18n";

export const useRegisterScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { loading, error, fieldErrors } = useAppSelector((state) => state.auth);

  const [accountName, setAccountName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const handleRegister = async (event?: FormEvent) => {
    event?.preventDefault();

    const result = await dispatch(
      registerUser({
        account_name: accountName,
        first_name: firstName,
        last_name: lastName || null,
        email,
        phone: phone || null,
        password,
        password_confirmation: passwordConfirmation,
      }),
    );

    if (registerUser.fulfilled.match(result)) {
      navigate(RouteNames.calendar, { replace: true });
    }
  };

  const getFieldError = (field: string) => {
    return fieldErrors[field]?.[0] || "";
  };

  return {
    accountName,
    firstName,
    lastName,
    email,
    phone,
    password,
    passwordConfirmation,

    setAccountName,
    setFirstName,
    setLastName,
    setEmail,
    setPhone,
    setPassword,
    setPasswordConfirmation,

    loading,
    error: error || "",
    getFieldError,

    handleRegister,
    goToLogin: () => navigate(RouteNames.login),

    t,
  };
};
